import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DemoBanner from '../components/DemoBanner';
import AdProvider from '../components/AdProvider';
import AdBanner from '../components/AdBanner';
import FullpageAd from '../components/FullpageAd';

const LOGO = '/dailyreps3.png';

export default function AdminLayout() {
  const { logout, teams, activeTeamId, activeTeam, setActiveTeam } = useAuth();

  return (
    <AdProvider>
      <div className="admin-layout">
        {activeTeam?.is_demo && <DemoBanner />}
        <header className="header">
          <div className="header-left">
            <img src={LOGO} alt="Train Daily" className="header-logo" />
            <div className="header-title">
              <span>Train Daily</span> Coach
              {activeTeam && (
                <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginLeft: 6 }}>
                  {activeTeam.name}
                </span>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {teams.length > 1 && (
              <select
                value={activeTeamId || ''}
                onChange={(e) => setActiveTeam(e.target.value)}
                style={{
                  background: 'var(--card-bg)',
                  color: 'var(--white)',
                  border: '1px solid var(--card-border)',
                  borderRadius: 8,
                  padding: '6px 8px',
                  fontSize: '0.8rem',
                  fontFamily: 'inherit',
                  outline: 'none',
                }}
              >
                {teams.map(t => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </select>
            )}
            <button className="header-logout" onClick={logout}>Log out</button>
          </div>
        </header>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Roster
          </NavLink>
          <NavLink to="/admin/communication" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Communication
          </NavLink>
          <NavLink to="/admin/drills" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Drills
          </NavLink>
          <NavLink to="/admin/seasons" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Challenges
          </NavLink>
          <NavLink to="/admin/leaderboard" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Leaderboard
          </NavLink>
          <NavLink to="/admin/reports" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Reports
          </NavLink>
          <NavLink to="/admin/library" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Drill Library
          </NavLink>
          <NavLink to="/admin/coaches" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Coaches
          </NavLink>
          <NavLink to="/admin/merch" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Merch
          </NavLink>
          <NavLink to="/admin/faq" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            FAQ
          </NavLink>
          <NavLink to="/admin/account" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
            Manage Account
          </NavLink>
        </nav>
        <AdBanner placement="top" />
        <Outlet />
        <AdBanner placement="bottom" />
        <div style={{ textAlign: 'center', padding: '24px 0 12px', fontSize: '0.85rem' }}>
          <a href="/support" style={{ color: 'var(--text-muted)' }}>Support</a>
        </div>
        <FullpageAd />
      </div>
    </AdProvider>
  );
}
